import React from 'react';
import { TeamMembersSectionProps } from '../../../../../Sections/AdditionalInfo/TeamMembersSection/TeamMembersSection';
import { ITeamMember } from '../../../../../../interfaces/professional/Professional';
import TeamMemberCard from '../../../../../Common/TeamMemberCard/TeamMemberCard';
import Container from '../../../../../Common/Container/Container';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import * as classes from './TeamMembersSection.module.scss';
import teamMembersDecorator from '../../../../../../assets/images/team-members-decorator.svg';

SwiperCore.use([Navigation]);

const TeamMembersSection = ({ members }: TeamMembersSectionProps) => {
  const { t } = useTranslation();

  const teamMembersMobileMapper = (item: ITeamMember, index: number) => (
    <div className='col-12 col-md-6' key={index}>
      <TeamMemberCard {...item} roundedImage />
    </div>
  );

  const teamMembersDesktopMapper = (item: ITeamMember, index: number) => (
    <SwiperSlide key={index}>
      <TeamMemberCard {...item} roundedImage />
    </SwiperSlide>
  );

  const TeamMembersMobile = <div className={'row d-lg-none'}>{members.map(teamMembersMobileMapper)}</div>;
  const TeamMembersDesktop = (
    <div className={'d-none d-lg-block swiper-modern-template testimonialsSlider'}>
      <Swiper slidesPerView={4} navigation spaceBetween={24}>
        {members.map(teamMembersDesktopMapper)}
      </Swiper>
    </div>
  );

  return (
    <section className={classes.wrapper} data-aos='fade-in'>
      <img src={teamMembersDecorator} alt='' className={classes.decorator} />
      <div className={classes.inner}>
        <Container>
          <div className={classes.sectionTitle}>
            {members.length > 1
              ? t('additionalInfo.teamMembersSection.titleText')
              : t('additionalInfo.teamMembersSection.titleTextOneMember')}
          </div>
          {TeamMembersMobile}
          {TeamMembersDesktop}
        </Container>
      </div>
    </section>
  );
};

export default TeamMembersSection;
